import { ManageOneLayerLookupTablesComponent } from "./admin/manage-one-layer-lookup-tables/manage-one-layer-lookup-tables.component";
import { NgModule } from "@angular/core";
import { StatusDynamicComponent } from "./status/status-dynamic/status-dynamic.component";
import { StatusStaticComponent } from "./status/status-static/status-static.component";
import { LogsComponent } from "./logs/logs.component";
import { DynamicImageLogsComponent } from "./admin/dynamic-image-logs/dynamic-image-logs.component";
import { UploadComponent } from "./upload/upload.component";
import { StaticComponent } from "./test-static/test-static.component";
import { PromoteDynamicComponent } from "./promote-dynamic/promote-dynamic.component";
import { RouterModule, Routes } from "@angular/router";
import { LayerSetComponent } from "./dynamic/layer-set/layer-set.component";
import { OptionMappingComponent } from "./dynamic/option-mapping/option-mapping.component";
import { PromoteStaticComponent } from "./promote-static/promote-static.component";
import { LayerSetMappingComponent } from "./dynamic/layer-set-mapping/layer-set-mapping.component";

import { RefreshCachesComponent } from "./admin/refresh-caches/refresh-caches.component";
import { ManageGlobalConfigsComponent } from "./admin/manage-global-configs/manage-global-configs.component";
import { ManageAssetProfileComponent } from "./admin/manage-asset-profile/manage-asset-profile.component";
import { FileBrowserComponent } from "./admin/file-browser/file-browser.component";
import { ManageImageSetComponent } from "./admin/manage-image-set/manage-image-set.component";
import { BatchSummaryComponent } from "./admin/batch-summary/batch-summary.component";
import { LandingPageComponent } from "./common/landing-page/landing-page.component";

const routes: Routes = [
  { path: "", redirectTo: "/start", pathMatch: "full" },
  {
    path: "status",
    children: [
      {
        path: "dynamic",
        component: StatusDynamicComponent,
      },
      {
        path: "static",
        component: StatusStaticComponent,
      },
    ],
  },
  { path: "start", component: LandingPageComponent },
  { path: "logs", component: LogsComponent },
  { path: "upload", component: UploadComponent },
  { path: "static", component: StaticComponent },
  {
    path: "promote",
    children: [
      {
        path: "dynamic",
        component: PromoteDynamicComponent,
      },
      {
        path: "static",
        component: PromoteStaticComponent,
      },
    ],
  },

  {
    path: "dynamic",
    children: [
      {
        path: "validate",
        component: LayerSetComponent,
      },
      {
        path: "options",
        component: OptionMappingComponent,
      },
      {
        path: "layers",
        component: LayerSetMappingComponent,
      },
    ],
  },
  {
    path: "admin",
    children: [
      {
        path: "refresh-caches",
        component: RefreshCachesComponent,
      },
      {
        path: "manage-global-configs",
        component: ManageGlobalConfigsComponent,
      },

      {
        path: "manage-oneLayer-lookupTables",
        component: ManageOneLayerLookupTablesComponent,
      },
      {
        path: "manage-asset-profiles",
        component: ManageAssetProfileComponent,
      },
      {
        path: "file-browser",
        component: FileBrowserComponent,
      },
      {
        path: "manage-image-sets",
        component: ManageImageSetComponent,
      },
      {
        path: "batch-summary",
        component: BatchSummaryComponent,
      },
      {
        path: "dynamic-image-logs",
        component: DynamicImageLogsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
